import React from 'react';
import "./Loader.css";
const Loader =  () => {
	return(
		<div className="spinner">
		  <div className="bounce1"></div>
		  <div className="bounce2"></div>
		  <div className="bounce3"></div>
		</div>
	)
}

export default Loader 


// WEBPACK FOOTER //
// ./src/Components/Loader/Loader.js